import * as React from "react"

interface Props {
    highlighted: boolean
    onSuggestionClick: (selectedSuggestion: Search.Suggestion) => void
    suggestion: Search.Suggestion
}

export default class Suggestion extends React.Component<Props> {
    render(): JSX.Element {
        const { highlighted, suggestion } = this.props
        return (
            <>
                {suggestion.original && (
                    <button
                        id={`smartSearchSuggestion_${suggestion.normalized}`}
                        className={`theme-thumb is-inverted theme-thumb--wide bg-cloud label tw-cursor-pointer ${
                            highlighted ? "is-focused" : ""
                        }`}
                        onMouseDown={this.onSuggestionClick}
                    >
                        {suggestion.original}
                    </button>
                )}
            </>
        )
    }

    onSuggestionClick = (ev: React.MouseEvent<HTMLElement>): void => {
        ev.preventDefault()
        ev.stopPropagation()
        const { onSuggestionClick, suggestion } = this.props
        onSuggestionClick(suggestion)
    }
}
